export const theme = Object.freeze({

});
